var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "mr-3 flex items-center text-sm mb-1" }, [
    _c(
      "span",
      { staticClass: "slot__container text-primary-500 mr-1 h-5 w-5" },
      [_vm._t("default")],
      2
    ),
    _c(
      "span",
      {
        staticClass: "font-semibold text-low-xs text-secondary-color",
        class: _vm.contentStyles,
      },
      [_vm._v(" " + _vm._s(_vm.contentData) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }